import { createContext } from "react";
import type { MorphemeCardTabHost } from "#morpheme-card-tab-host";

/** Allows a card to host its info navigation outside the reference content. */
export const MorphemeInfoTabHostContext = createContext<MorphemeCardTabHost | null>(null);
